import { CommonModule } from '@angular/common';
import { Component, inject, input, TemplateRef } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, RouterLink, RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { filter, map, Observable, of, startWith, tap } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

type MenuItem = {
  id: string;
  type: string;
  label?: string;
  iconClass?: string;
  route?: string[];
  cssClass?:Observable<string>|((item:MenuItem)=>Observable<string>);
  permission?: (item:MenuItem)=>Observable<boolean>;
}
const SITE_MENU_ITEMS:MenuItem[] = [
  {
    id: 'home',
    type: 'link',
    label: 'Home',
    iconClass: 'fa-solid fa-landmark-dome',
    route: ['/'],
    permission: (item:MenuItem)=>{return of(true);}
  },
  {
    id: 'discussion',
    type: 'link',
    label: 'Discussions',
    iconClass: 'fa-regular fa-comments',
    route: ['/discussion'],
    permission: (item:MenuItem)=>{return of(true);}
  },
  {
    id: 'concepts',
    type: 'link',
    label: 'Concepts',
    iconClass: 'fa-regular fa-file-lines',
    route: ['/concept'],
    permission: (item:MenuItem)=>{return of(true);}
  },
  {
    id: 'founding',
    type: 'link',
    label: 'GovDesign',
    iconClass: 'fa-solid fa-compass-drafting',
    route: ['/government'],
    permission: (item:MenuItem)=>{return of(true);}
  },
  {
    id: 'news',
    type: 'link',
    label: 'News',
    iconClass: 'fa-regular fa-newspaper',
    route: ['/news'],
    permission: (item:MenuItem)=>{return of(true);}
  },
  // {
  //   id: '',
  //   type: '',
  //   label: '',
  //   route: [''],
  //   permission: (item:typeof SITE_MENU_ITEMS)=>{return true;}
  // },
]

@Component({
  selector: 'usar-top-bar',
  imports: [RouterModule, RouterLink, CommonModule],
  // providers: [ActivatedRoute],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss'
})
export class TopBarComponent {

  protected readonly _authService = inject(AuthService);
  public readonly _sanitize = inject(DomSanitizer);
  private offcanvasService = inject(NgbOffcanvas);

  public layout = input('collapsed');
  
  private readonly router = inject(Router);
  // private readonly isMainPage$ = this.router.events.pipe(
  //   filter((event): event is NavigationEnd => event instanceof NavigationEnd),
  //   map((event: NavigationEnd) => event.url === '/'),
  //   startWith(true)
  // );

  public currPath = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map(item=>this.router.url),
    startWith(this.router.url),
  );

  public items = SITE_MENU_ITEMS;
  public activeChecks$:{[k:string]:Observable<boolean>} = {};
  
  userImage(val:string){
    return this._sanitize.bypassSecurityTrustResourceUrl(val);
  }

  // isMainPage = toSignal(this.isMainPage$);
  
	open(content: TemplateRef<any>) {
		this.offcanvasService.open(content, { ariaLabelledBy: 'offcanvas-basic-title' }).result.then(
			(result) => {
				// this.closeResult.set(`Closed with: ${result}`);
			},
			(reason) => {
				// this.closeResult.set(`Dismissed ${this.getDismissReason(reason)}`);
			},
		);
	}

  isActive(item:MenuItem){
    if (!this.activeChecks$[item.id]){
      this.activeChecks$[item.id] = this.currPath.pipe(
        map(path=>{
          let checkedRoute = item.route?.join('/');
          return (checkedRoute=='/')?checkedRoute==path:path.startsWith(checkedRoute ?? '')
        }),
      )
    }
    return this.activeChecks$[item.id];
  }

}
